module.exports = __webpack_public_path__ + "img/reset-bg.de2c77db.png";